import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-up', 'ArrowUp', [["path",{"d":"M12 19.5v-15m6 5.625L12 4.5l-6 5.625","key":"svg-0"}]]);